import BioItem from './BioItem';

export default BioItem;
